/**
 * @generated SignedSource<<5c759f4c8ec6aa8e1ab24bb9bcad1840>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TermDrawer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"getTermURL">;
  readonly " $fragmentType": "TermDrawer";
};
export type TermDrawer$key = {
  readonly " $data"?: TermDrawer$data;
  readonly " $fragmentSpreads": FragmentRefs<"TermDrawer">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "corpType"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "termsType"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "corpType",
    "variableName": "corpType"
  },
  {
    "kind": "Variable",
    "name": "termsType",
    "variableName": "termsType"
  }
];
return {
  "argumentDefinitions": (v0/*: any*/),
  "kind": "Fragment",
  "metadata": null,
  "name": "TermDrawer",
  "selections": [
    {
      "kind": "InlineDataFragmentSpread",
      "name": "getTermURL",
      "selections": [
        {
          "alias": null,
          "args": (v1/*: any*/),
          "concreteType": "RefundTermsOutput",
          "kind": "LinkedField",
          "name": "refundTerms",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "termsKey",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "url",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "args": (v1/*: any*/),
      "argumentDefinitions": (v0/*: any*/)
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "939b6eb7b3f6649c017f70974a6bab0b";

export default node;
